// removed by extract-text-webpack-plugin
module.exports = {"main":"_3GaLRmFeAt0HW4dp-ERUdh"};


//////////////////
// WEBPACK FOOTER
// ./pages/workspace-warehouses/components/warehouse-setup/index.module.css
// module id = 2412
// module chunks = 0